import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from './config';

function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [otp, setOtp] = useState('');

  const isFormIncomplete = !email || !password || !otp;
  const isEmailEmpty = !email.trim();

  const handleSendCode = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/v1/token/otp`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      if (!response.ok) throw new Error('コード送信に失敗しました');
      alert('認証コードを送信しました');
    } catch (err) {
      console.error(err);
      alert('認証コード送信中にエラーが発生しました');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(`${API_BASE_URL}/v1/token`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password, otp }),
      });

      const data = await response.json();

      if (data.access_token) {
        localStorage.setItem('access_token', data.access_token);
        navigate('/dashboard');
      } else {
        alert('ログインに失敗しました（トークンがありません）');
      }
    } catch (err) {
      console.error(err);
      alert('ログインに失敗しました（通信エラー）');
    }
  };

  return (
    <div className="login-box container mt-5" style={{ maxWidth: '400px' }}>
      <h2 className="mb-4 text-center">管理者ログイン</h2>
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label htmlFor="email" className="form-label">
            メールアドレス <span className="text-danger">*</span>
          </label>
          <input
            type="email"
            id="email"
            className="form-control"
            placeholder="admin@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="mb-3">
          <label htmlFor="password" className="form-label">
            パスワード <span className="text-danger">*</span>
          </label>
          <input
            type="password"
            id="password"
            className="form-control"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <div className="mb-3 d-flex align-items-end gap-3">
          <div className="flex-grow-1">
            <label className="form-label">
              認証コード <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="メールに届いたコードを入力"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              required
            />
          </div>
          <div>
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={handleSendCode}
              disabled={isEmailEmpty}
            >
              認証コード送信
            </button>
          </div>
        </div>
        <button
          type="submit"
          className="btn btn-primary w-100"
          disabled={isFormIncomplete}
        >
          ログイン
        </button>
      </form>
    </div>
  );
}

export default AdminLogin;
